import { CheckboxWebElementBase } from './CheckboxWebElementBase';
import { By, Key, error } from 'selenium-webdriver';

/**
 * The component WebElement for [oj-c-checkbox](../../jsdocs/oj-c.Checkbox.html).
 * Do not instantiate this class directly, instead, use
 * [findCheckbox](../functions/findCheckbox.html).
 */
export class CheckboxWebElement extends CheckboxWebElementBase {
  /**
   * Sets the value of "value" property for the Checkbox component
   * @param value The value to set for "value"
   * @throws {ElementNotInteractableError} if the API is called when the control is readonly or disabled
   */
  public async changeValue(value: boolean): Promise<void> {
    // Check if the control is interactable
    if (!(await this.isInteractable())) {
      // Cannot interact when the control is disabled or readonly
      throw new error.ElementNotInteractableError(
        'oj-c-checkbox: Value cannot be changed when the control is disabled or readonly'
      );
    }

    await this.whenBusyContextReady();
    await this.selectValue(value);
  }

  /**
   * Checks if the Checkbox is in interactable state
   */
  private async isInteractable(): Promise<boolean> {
    const isReadonly = await this.getReadonly();
    const isDisabled = await this.getDisabled();
    return !(isReadonly || isDisabled);
  }

  /**
   * Toggle Checkbox value if needed
   */
  private async selectValue(value: boolean | null): Promise<void> {
    const label = await this.findElement(By.css('label'));
    const input = await label.findElement(By.css('input'));
    const checked = await input.isSelected();

    if (checked !== value) {
      await label.sendKeys(Key.SPACE);
    }
  }
}
